import React from 'react';
import './Footer.css'

const Footer = () => {
    return (
        <div className='footer'>
            <p><small>copyright @ 2022</small></p>
        </div>
    );
};

export default Footer;